import React, { useEffect, useRef } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import { useState } from "react";
import './index.css'
import { GetUser, UpdateUser, ForgotPassword } from '../../ApiRequests'
import Cookies from 'universal-cookie'
import cookieUtils from "../../Utilities/CookieUtils";


const Profile = (props) => {
    const cookies = new Cookies()
    const cookie = cookies.get('jwt')
    const { scope, userId } = cookieUtils.getScopeFromJWT(cookie)

    const [showResetPassword, setShowResetPassword] = useState(false)
    const [edit, setEdit] = useState(false)

    const [user, setUser] = useState({})
    const [displayName, setDisplayName] = useState('');
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('')

    const originalUser = useRef({})

    const getUser = async () => {
        const userId = localStorage.getItem('userID')
        const userData = await GetUser(userId)

        if (!userData) { return }
        if ('data' in userData) {
            setUser(userData.data)
            setDisplayName(userData.data.displayName)
            setEmail(userData.data.userName)
            originalUser.current = userData.data
        } else {
            console.log('user has no data')
            return null
        }
    }

    const updateUser = async () => {
        const res = await UpdateUser(originalUser.current)
        if (res && res.data){
            getUser(res.data)
            setEdit(false)
        } else {
            console.log("User could not be updated. ")
            setEdit(false)
        }
    }

    const handleSaveUserSettings = async () => {
        originalUser.current.userName = originalUser.current.userName == email ? originalUser.current.userName : email.trim().toLowerCase()
        originalUser.current.displayName = displayName
        await updateUser()
        setEdit(false)
    }

    const handleRevertUserSettings = () => {
        setEmail(originalUser.current.userName)
        setDisplayName(originalUser.current.displayName || '')
        setConfirmEmail('')
        setEdit(false)
    }

    const handleResetPassword = async () => {
        ForgotPassword(originalUser.current.userName)
        setShowResetPassword(false)
    }


    useEffect(() => {
        getUser()
    }, []);



    return (
        <div className="container py-3" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            <div className="p-4 d-flex flex-row justify-content-center w-100">
                <Card className='w-100' style={{ maxWidth: '800px' }}>
                    <Card.Body className="px-2 px-md-5" disabled>
                        <div className="fs-5 fw-bold w-100 d-flex justify-content-md-center mb-3">User Settings</div>
                        {user != {} && <>
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="text" disabled={!edit || originalUser.current.password==null} value={email} onChange={(e) => setEmail(e.target.value)} />
                            {edit && originalUser.current.userName != email && < Form.Control type="text" className="mt-2" value={confirmEmail} placeholder='Confirm Email' onChange={(e) => setConfirmEmail(e.target.value)} />}
                            <br />
                            <Form.Label>Display Name</Form.Label>
                            <Form.Control type="text" disabled={!edit} value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder='Display Name' />
                            <br />
                            {originalUser.current.password != null && < Button variant='link' className="mb-4 mb-md-0" onClick={() => setShowResetPassword(true)}>Reset Password</Button>}
                            <br />
                            <div className="row d-flex flex-row justify-content-end w-100 ms-0">
                                {edit ? 
                                <>
                                    {originalUser.current.userName != email && (email.trim().toLowerCase() != confirmEmail.trim().toLowerCase()) && <div className="fw-light d-flex align-items-center me-2 col-md" style={{ color: 'red' }}>Emails do not match.</div>}
                                    <Button variant='outline-secondary' className="me-0 me-md-2 col-md-2" onClick={() => handleRevertUserSettings()}>Cancel</Button>
                                    <Button variant='primary' className="col-md-2 my-2 my-md-0" disabled={originalUser.current.userName != email && email.trim().toLowerCase() != confirmEmail.trim().toLowerCase()} onClick={() => handleSaveUserSettings()}>Save</Button>
                                </> :
                                    <Button variant='secondary' className="col-sm-2" onClick={() => setEdit(true)}>Edit</Button>}
                            </div>

                        </>
                        }
                    </Card.Body>
                </Card>
            </div>


            <Modal show={showResetPassword} onHide={() => setShowResetPassword(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Reset Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Are you sure you want to reset your password?  </Form.Label>
                    <Form.Label>An email will be sent to {originalUser.current.userName} with further instructions. </Form.Label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => setShowResetPassword(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => handleResetPassword()}>
                        Reset Password
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Profile;